import {
  DEFAULT_START_TIME_12HR,
  DEFAULT_END_TIME_12HR,
  DEFAULT_START_TIME_24HR,
  DEFAULT_END_TIME_24HR,
  DEFAULT_DURATION,
  DEFAULT_DURATION_30MIN,
} from "./constants";

/**
 * Reset manual time state to default values
 * @param {Object} setters - Object containing setter functions
 * @param {Function} setters.setStartTimeManual - Setter for start time (12hr)
 * @param {Function} setters.setEndTimeManual - Setter for end time (12hr)
 * @param {Function} setters.setStartTimeManual24 - Setter for start time (24hr)
 * @param {Function} setters.setEndTimeManual24 - Setter for end time (24hr)
 * @param {Function} setters.setUFormatedTimeManual - Setter for formatted duration
 * @param {Function} setters.setSplitted - Setter for splitted state
 * @param {Function} setters.setSplittedDate - Setter for splitted date
 * @param {Function} setters.setUManualStartTimeError - Setter for start time error
 * @param {Function} setters.setUManualEndTimeError - Setter for end time error
 * @param {Function} setters.setUManualFormatedTimeError - Setter for formatted time error
 * @param {boolean} use30MinDuration - If true, use 30 minute duration instead of 0
 */
export function resetManualTimeState(
  {
    setStartTimeManual,
    setEndTimeManual,
    setStartTimeManual24,
    setEndTimeManual24,
    setUFormatedTimeManual,
    setSplitted,
    setSplittedDate,
    setUManualStartTimeError,
    setUManualEndTimeError,
    setUManualFormatedTimeError,
  },
  use30MinDuration = false
) {
  setStartTimeManual(DEFAULT_START_TIME_12HR);
  setEndTimeManual(DEFAULT_END_TIME_12HR);
  setStartTimeManual24(DEFAULT_START_TIME_24HR);
  setEndTimeManual24(DEFAULT_END_TIME_24HR);
  setUFormatedTimeManual(use30MinDuration ? DEFAULT_DURATION_30MIN : DEFAULT_DURATION);
  setSplitted(false);
  setSplittedDate([]);
  setUManualStartTimeError(false);
  setUManualEndTimeError(false);
  setUManualFormatedTimeError(false);
}
